import { LowStockVariantId } from '@services/MarppleShop/features/ProductMeta';

export const LOW_STOCK_VARIANT_LABEL: Record<LowStockVariantId, string> = {
  [LowStockVariantId.THRESHOLD_INFINITY]: '항상 공개',
  [LowStockVariantId.THRESHOLD_10]: '총 10개 미만 시',
  [LowStockVariantId.THRESHOLD_100]: '총 100개 미만 시',
};
